document.addEventListener("DOMContentLoaded", (event) => {
  
  document.querySelectorAll('.product-collections-section').forEach((section) => {
    const tabs = section.querySelectorAll('.card-tabs .card-tab');
    const tabContents = section.querySelectorAll('.card-tab-cotent .card-tab-item');

    tabs.forEach((item) => {
        item.addEventListener('click', (e) => {
            let clickedTab = e.currentTarget;
            let cardTab = clickedTab.dataset.cardTab;

            // If the clicked tab is already active, do nothing
            if (clickedTab.classList.contains('active')) {
                return;
            }

            // Deactivate all tabs and contents within this section only
            tabs.forEach((cardItem) => cardItem.classList.remove('active'));
            tabContents.forEach((contentItem) => contentItem.classList.remove('active'));

            // Activate the clicked tab and its content
            clickedTab.classList.add('active');
            section.querySelector(`.card-tab-cotent .card-tab-item[data-card-tab="${cardTab}"]`)
                ?.classList.add('active');
        });
    });
});


  // Brand slider Js
  let brandSlider = document.querySelector('.brand-list-slider');
  if(brandSlider){
    var flkty = new Flickity( brandSlider, {
      wrapAround:true,
      imagesLoaded: true,
      cellAlign: 'center', 
      contain: true, 
      freeScroll: true, 
      autoPlay:true, 
      prevNextButtons: false, 
      pageDots: false 
    });  
  }

  // Testimonial slider Js
  let testimonial = document.querySelector('.testimonial-slider');
  if(testimonial){
    var flkty = new Flickity( testimonial, {
      wrapAround:true,
      cellAlign: 'left',
      contain: true,
      // Always start with autoPlay off: Flickity's own autoPlay bootstrap
      // can begin asynchronously (e.g. after images finish loading), which
      // can race an immediate pausePlayer() call below and start playing
      // anyway with nothing left to stop it. updateTestimonialDraggable()
      // explicitly calls playPlayer() once overflow is confirmed instead.
      autoPlay:false,
      prevNextButtons: false,
      pageDots: true
    });

    // When every card already fits in view (no overflow), dragging has
    // nothing to reveal but Flickity still lets you pull the strip left,
    // which briefly hides the first card before it snaps back. Disable
    // dragging in that case; re-enable it once cards overflow (tablet/mobile).
    // Flickity positions cells with transforms rather than native scrolling,
    // so the container's own scrollWidth/clientWidth are always equal —
    // measure the cells' actual rendered widths instead.
    var testimonialHasOverflow = false;
    var checkTestimonialOverflow = function () {
      var cells = testimonial.querySelectorAll('.testimonial-item');
      var totalCellWidth = 0;
      cells.forEach(function (cell) {
        totalCellWidth += cell.getBoundingClientRect().width;
      });
      return totalCellWidth > testimonial.clientWidth + 1;
    };
    var updateTestimonialDraggable = function () {
      testimonialHasOverflow = checkTestimonialOverflow();
      flkty.options.draggable = testimonialHasOverflow;
      flkty.updateDraggable();
      if (testimonialHasOverflow) {
        flkty.playPlayer();
      } else {
        flkty.pausePlayer();
      }
    };
    updateTestimonialDraggable();

    // Debounce: a resize event can fire many times while the browser is
    // actively resizing (window drag, orientation change, zoom), and a
    // mid-resize layout can transiently mismeasure cell widths before
    // everything settles. Only recompute once resizing has stopped, so a
    // one-off bad reading can't leave autoPlay/dragging stuck enabled.
    var testimonialResizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(testimonialResizeTimeout);
      testimonialResizeTimeout = setTimeout(updateTestimonialDraggable, 200);
    });

    // Even with dragging disabled, Flickity's wrapAround cell-positioning can
    // still render a cell (usually the first one) at its "wrapped" off-screen
    // position after a pointer drag on the slider — a Flickity quirk, not
    // something `draggable: false` alone prevents. When there's nothing to
    // actually slide, force a clean reposition after any such interaction.
    ['mouseup', 'touchend'].forEach(function (evt) {
      testimonial.addEventListener(evt, function () {
        if (testimonialHasOverflow) return;
        setTimeout(function () {
          flkty.reloadCells();
          flkty.resize();
          flkty.select(0, false, true);
        }, 0);
      });
    });
  }

  // Hero banner slider
  
  let heroBanner = document.querySelector('.hero-banner-slider');
  if(heroBanner){
    var flkty = new Flickity( heroBanner, {
      wrapAround:true,
      cellAlign: 'left',
      autoPlay:5000,
      contain: true, 
      prevNextButtons: false, 
      pageDots: true 
    });  
  }

});